import type { IconProps as Props } from './types';

export const IconExchangeExperience = ({
  className,
  width = '48',
  height = '48',
  stroke = 'currentColor',
  strokeWidth = '2.5',
  fill = 'none',
  ...props
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.046 18.696H42.03L35.668 12.33C33.6198 10.2817 31.0684 8.80879 28.2704 8.05921C25.4725 7.30964 22.5264 7.30986 19.7286 8.05985C16.9307 8.80984 14.3795 10.2832 12.3316 12.3317C10.2837 14.3803 8.81114 16.9319 8.06202 19.73M5.97002 39.288V29.304M5.97002 29.304H15.954M5.97002 29.304L12.33 35.67C14.3783 37.7183 16.9296 39.1912 19.7276 39.9408C22.5256 40.6904 25.4716 40.6902 28.2695 39.9402C31.0674 39.1902 33.6185 37.7168 35.6664 35.6683C37.7143 33.6197 39.1869 31.0681 39.936 28.27M42.03 8.712V18.692"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
